import { CrmCredentialsRequest, CrmCredentialsUpdateRequest, CrmCredentialsResponse } from '../types';
import { apiClient } from './api';

export const crmApi = {
  // Assistant CRM credentials
  async setAssistantCrmCredentials(assistantId: string, credentials: CrmCredentialsRequest): Promise<CrmCredentialsResponse> {
    return await apiClient.post<CrmCredentialsResponse>(`/admin/assistants/${assistantId}/crm-credentials`, credentials);
  },

  async getAssistantCrmCredentials(assistantId: string): Promise<CrmCredentialsResponse> {
    return await apiClient.get<CrmCredentialsResponse>(`/admin/assistants/${assistantId}/crm-credentials`);
  },

  async updateAssistantCrmCredentials(assistantId: string, credentials: CrmCredentialsUpdateRequest): Promise<CrmCredentialsResponse> {
    return await apiClient.put<CrmCredentialsResponse>(`/admin/assistants/${assistantId}/crm-credentials`, credentials);
  },

  async deleteAssistantCrmCredentials(assistantId: string): Promise<CrmCredentialsResponse> {
    return await apiClient.delete<CrmCredentialsResponse>(`/admin/assistants/${assistantId}/crm-credentials`);
  },

  // Workflow CRM credentials
  async setWorkflowCrmCredentials(workflowId: string, credentials: CrmCredentialsRequest): Promise<CrmCredentialsResponse> {
    return await apiClient.post<CrmCredentialsResponse>(`/admin/workflows/${workflowId}/crm-credentials`, credentials);
  },

  async getWorkflowCrmCredentials(workflowId: string): Promise<CrmCredentialsResponse> {
    return await apiClient.get<CrmCredentialsResponse>(`/admin/workflows/${workflowId}/crm-credentials`);
  },

  async updateWorkflowCrmCredentials(workflowId: string, credentials: CrmCredentialsUpdateRequest): Promise<CrmCredentialsResponse> {
    return await apiClient.put<CrmCredentialsResponse>(`/admin/workflows/${workflowId}/crm-credentials`, credentials);
  },

  async deleteWorkflowCrmCredentials(workflowId: string): Promise<CrmCredentialsResponse> {
    return await apiClient.delete<CrmCredentialsResponse>(`/admin/workflows/${workflowId}/crm-credentials`);
  },
};